import { get, put } from '../../shared/api/apiService';
import { useApiEssentials } from '../../shared/hooks/useApiEssentials';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { User } from '@app/shared/types';

export function useGetMe() {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials();

  return useQuery({
    queryKey: ['user', 'me'],
    queryFn: async () => {
      const idToken = await getIdToken();
      return await get<User>(`/users/me`, apiUrl, idToken);
    },
    enabled: isSignedIn,
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export function useUpdateMe() {
  const { getIdToken, apiUrl } = useApiEssentials();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData: User) => {
      const idToken = await getIdToken();
      return await put<User>(`/users/me`, userData, apiUrl, idToken);
    },
    onSuccess: updatedUser => {
      queryClient.setQueryData(['user', 'me'], updatedUser);
    },
  });
}
